import React from 'react';
import { Form } from 'react-bootstrap';

import HeaderImageEditor from './HeaderImageEditor';
import '../../EditWidget/EditWidget.scss';

interface EditHeaderProps {
	editModalInputFields?: any;
	setEditModalInputFields: (fields: any) => void;
	t: (key: string, params?: any) => string;
	setHeaderImageUrl: (file: File | null) => void;
	widgetId: string;
}

const EditHeader: React.FC<EditHeaderProps> = ({
	editModalInputFields,
	setEditModalInputFields,
	t,
	setHeaderImageUrl,
	widgetId,
}) => {
	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		setEditModalInputFields((prevFields: any) => ({
			...prevFields,
			[widgetId]: {
				...prevFields[widgetId],
				[e.target.name]: e.target.value,
			},
		}));
	};

	return (
		<div className="edit-widget-modal-content">
			<Form.Group key="headerImage" className="mb-3">
				<Form.Label>{t('headerImage')}</Form.Label>
				<HeaderImageEditor
					editModalInputFields={editModalInputFields}
					setEditModalInputFields={setEditModalInputFields}
					setHeaderImageUrl={setHeaderImageUrl}
					t={t}
					widgetId={widgetId}
				/>
			</Form.Group>
			<Form.Group className="mb-3">
				<div
					className={`position-relative ${editModalInputFields?.[widgetId]?.headerTitle?.length > 16 ? 'border-danger' : ''}`}
				>
					<Form.Label>{t('editHeaderTitle')}</Form.Label>
					<Form.Control
						className={`${editModalInputFields?.[widgetId]?.headerTitle?.length > 16 && 'is-invalid'} pe-7`}
						name="headerTitle"
						placeholder="Enter..."
						type="text"
						value={editModalInputFields?.[widgetId]?.headerTitle}
						onChange={handleInputChange}
					/>
					<span
						className={`character-count position-absolute end-0 pe-2 small fw-bold ${editModalInputFields?.[widgetId]?.headerTitle?.length > 16 ? 'text-danger' : 'text-muted'}`}
					>
						{editModalInputFields?.[widgetId]?.headerTitle?.length}/{16}
					</span>
				</div>
				{editModalInputFields?.[widgetId]?.headerTitle?.length > 16 && (
					<div className="text-danger small mt-1">
						{t('mustBeLessThanNCharacters', { n: 16 })}
					</div>
				)}
			</Form.Group>
			<Form.Group className="mb-3">
				<div
					className={`position-relative ${editModalInputFields?.[widgetId]?.headerSubtitle?.length > 100 ? 'border-danger' : ''}`}
				>
					<Form.Label>{t('editHeaderSubtitle')}</Form.Label>
					<Form.Control
						as="textarea"
						className={`${editModalInputFields?.[widgetId]?.headerSubtitle?.length > 100 && 'is-invalid'} pe-7 overflow-hidden`}
						name="headerSubtitle"
						placeholder="Enter..."
						value={editModalInputFields?.[widgetId]?.headerSubtitle}
						onChange={handleInputChange}
					/>
					<span
						className={`character-count-subtitle position-absolute end-0 pe-2 overflow-hidden small fw-bold ${editModalInputFields?.[widgetId]?.headerSubtitle?.length > 100 ? 'text-danger' : 'text-muted'}`}
					>
						{editModalInputFields?.[widgetId]?.headerSubtitle?.length}/{100}
					</span>
				</div>
				{editModalInputFields?.[widgetId]?.headerSubtitle?.length > 100 && (
					<div className="text-danger small mt-1">
						{t('mustBeLessThanNCharacters', { n: 100 })}
					</div>
				)}
			</Form.Group>
		</div>
	);
};

export default EditHeader;
